import { render, staticRenderFns } from "./occupySeat.vue?vue&type=template&id=f6651692"
import script from "./occupySeat.vue?vue&type=script&lang=js"
export * from "./occupySeat.vue?vue&type=script&lang=js"
import style0 from "./occupySeat.vue?vue&type=style&index=0&id=f6651692&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports